import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/abschlussarten/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="ClosureType"
      returnRoute="/auswahlfelder/closureType"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const ClosureTypeRoute = Route;
